module.exports = __webpack_public_path__ + "img/review_banner_google.b0b12879.png";